import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";
import { Container, Row, Col, Button, Stack } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import moment from "moment";
import { toast } from "react-toastify";

import { useAuthContext } from "../../contexts/AuthContext";
import ProjectStructureService from "../../services/projectStructure.service";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import "./Structure.scss";

const perPage = 10;

function Structures() {

  let { projectId } = useParams();

  const aggridRef = useRef();

  const navigate = useNavigate();
  const { user, setIsLoading } = useAuthContext();

  const [structureList, setStructureList] = useState([]);
  const [pageSize, setPageSize] = useState();

  useEffect(() => {
    if(user){
      retrieveStructureDetails();
    }
  }, [user, projectId])
  

  function retrieveStructureDetails() {
    setIsLoading(true);
    ProjectStructureService.getByProject(projectId).then((response) => {
      setIsLoading(false);
      setStructureList(response.data.data);
    });
  }

  function deleteStructure(id) {
    setIsLoading(true);
    ProjectStructureService.delete(id).then((response) => {
      setIsLoading(false);
      if(response.data.success){
        const updatedStructure = structureList.filter((item) => item.id !== id);
        setStructureList(updatedStructure);
        toast.error("Structures Deleted!");
      } else {
        toast.error("Error in deleting Structure");
      }
    });
  }

  function onPageSizeChanged(e) {
    let value = e.target.value;
    setPageSize(value);
    aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  const columnDefs = [
      {headerName: "Structure Name", field: "structureName", filter: true, sortable:true, width:"250"},
      {headerName: "File Type", field: "fileType.name",filter: true,  sortable:true, width:"150"},
      {headerName: "File Format", field: "fileFormat",filter: true,  sortable:true, width:"200"},
      {headerName: "Modified By", field: "modifiedBy.name",filter: true,  sortable:true, width:"120",
        cellRendererFramework: (data) => {
          return (!data.value ? "admin" :  data.value)
          } 
      },
      {headerName: "Updated At", field: "updatedAt",filter: true,  sortable:true, width:"160",
        cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "Action", field:"id", width:"120",
        cellRendererFramework: (data) => {
           return <>
                <Link title="Details" className="text-primary mr-4 margin-right" to={"/project/"+projectId+"/structure/"+data.value+"/detail"}><TiEyeOutline  size="25" /></Link>
                <Link title="Edit" className="text-success mr-2 margin-right" to={"/project/"+projectId+"/structure/"+data.value+"/edit"}><TiEdit  size="25" /></Link>
                {user && user?.role === "superadmin" && (
                  <span className="text-danger cursor-pointer" title="delete" onClick={() => deleteStructure(data.value)}><TiDeleteOutline size="25" /></span>
                )}
            </>
        }
        
      }
    ];

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 pageTitle">Structures List</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button variant="primary" className="mt-4" onClick={() => navigate(`/project/${projectId}/structure/create`)}><FcPlus /> Create Structure</Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
            {structureList && structureList.length > 0 ? (
              <div className="example-header">
                Page Size: &nbsp;
                <select onChange={onPageSizeChanged} id="page-size" value={pageSize}>
                  <option value="10">
                    10
                  </option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
            ) : (
              <h6>No structure Found</h6>
            )}
            
            {structureList && structureList.length > 0 && projectId && (
              <AgGridReact
                  ref={aggridRef}
                  pagination={true}
                  rowHeight={50}
                  paginationPageSize={perPage}
                  columnDefs={columnDefs}
                  rowData={structureList}>
              </AgGridReact>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Structures;
